






























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";

import _ from "lodash";


axios.defaults.baseURL = process.env.BASE_URL;

@Component({
    computed: mapGetters(["getUser"]),
})


export default class NeuroscienceEvaluationScores extends Vue {


    qId = "";
    infomsg = "";
    scores: any = {};
    baseurl = process.env.BASE_URL;

    dominateBrain: any = {};
    supportiveBrain: any = {};

    CombinaisonBrain: any = {};

    dominantSupportiveBrains: any = {};
    supportBrains: any = {};


    cover = false;
    notice = false;

    handlePrintNeuroscience() {
        this.$bvModal.show('modal-project');
    }


    // Fonction pour télécharger le fichier Excel
    downloadExcel() {
        this.$toast.info("La création de l'excel est en cours.");
        axios({
            url: `/api/excelEvaluationNeuroscienceQuestionnaire?id=`+this.qId,
            method: 'GET',
            responseType: 'blob', // important pour gérer les fichiers binaires
        })
            .then((response) => {
                // Création d’un lien de téléchargement
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Nom du fichier (extrait depuis le header ou défini manuellement)
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'questionnaire.xlsx';
                if (contentDisposition && contentDisposition.includes('filename=')) {
                    filename = contentDisposition
                        .split('filename=')[1]
                        .replace(/['"]/g, '')
                        .trim();
                }

                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                this.$toast.error("Oops, Nous avons rencontré un probleme lors de la création du fichier excel !");
            });
    }


    printNeuroscienceReport() {
        this.$toast.info("La création du rapport est en cours.");
        try {
            window.open("http://127.0.0.1:5000/printReportNeuroscience/?id=" + this.qId + "&cover=" + this.cover + "&notice=" + this.notice, "_blank");
            this.$bvModal.hide('modal-project');
        }
        catch (err) {
            this.$toast.error("Oops, Nous avons rencontré un probleme lors de la création du rapport !");
        }
    }

    fetch_data() {
        axios
            .get("/api/depouillateNeuroscienceEvaluation", { params: { id: this.qId } })
            .then(ans => {

                this.infomsg = "";
                this.scores = ans.data.scores;


                const dictEntries = Object.entries(this.scores.dominantSupportiveBrains as Record<string, any>)
                const sortedEntries = dictEntries.sort((a, b) => b[1]['total_n_per_A'] - a[1]['total_n_per_A'])
                this.dominantSupportiveBrains = Object.fromEntries(sortedEntries)

                //this.dominantSupportiveBrains = this.scores.dominantSupportiveBrains;
                console.log(this.dominantSupportiveBrains)

                this.dominateBrain = Object.keys(this.dominantSupportiveBrains)[0];
                this.supportiveBrain = Object.keys(this.dominantSupportiveBrains)[1];

                this.supportBrains = this.scores.supportBrains;

            })
            .catch(err => {
                this.$toast.error("Oops, le chargement a échoué !");
            });

        axios
            .get("/api/CombinaisonBrain")
            .then(ans => {
                this.CombinaisonBrain = ans.data;
            })

    }


    mounted() {

        this.qId = (this.$route.query.id as string) || "";
        this.fetch_data();
    }
}
